// src/api/pyqApi.js
//
// Student-facing PYQ practice API calls, matching liveSessionsApi.js's
// convention (askosAuthHeader() passed explicitly per call).
import api from './api';
import { askosAuthHeader } from '../askos/askosApi';

export const listPyq = (slug, params = {}) =>
  api.get(`/tenant/${slug}/askos/pyq`, { headers: askosAuthHeader(), params }).then(r => r.data);

export const attemptPyq = (slug, questionId, payload) =>
  api.post(`/tenant/${slug}/askos/pyq/${questionId}/attempt`, payload, { headers: askosAuthHeader() }).then(r => r.data);

export const getPyqStats = (slug) =>
  api.get(`/tenant/${slug}/askos/pyq/stats`, { headers: askosAuthHeader() }).then(r => r.data);

export const getPyqPaperPdfUrl = (slug, subjectProjectId, paper, download = false) =>
  api.get(`/tenant/${slug}/askos/pyq/paper-pdf`, {
    headers: askosAuthHeader(),
    params: { subject_project_id: subjectProjectId, paper, download },
  }).then(r => r.data.url);
